import {Injectable} from "@angular/core";
import {Router, NavigationStart} from "@angular/router";
import {Subject, Observable} from "rxjs";

@Injectable()
export class AlertService
{


	/**
	 * Attribute
	 */
	private OBJ_subject = new Subject<any>();
	private BOO_keep_after_navigation_change = false;
	private OBJ_message_after_navigation_change = null;


	/**
	 * Function > constructor
	 * @param {object} OBJ_router
	 */
	constructor(private OBJ_router: Router)
	{

		// clear alert message on route change
		OBJ_router.events.subscribe(OBJ_event => {

			if (OBJ_event instanceof NavigationStart)
			{

				if (this.BOO_keep_after_navigation_change)
				{
					// only keep for a single location change
					this.BOO_keep_after_navigation_change = false;
				}
				else
				{
					// clear alert
                    this.OBJ_message_after_navigation_change = null;
					this.OBJ_subject.next();
				} // end if

			} // end if

		});

	} // end function constructor


	/**
	 * Function > success
	 * @param {string} STR_message
	 * @param {boolean} BOO_keep_after_navigation_change
	 */
	success(STR_message: string, BOO_keep_after_navigation_change = false)
	{

		this.BOO_keep_after_navigation_change = BOO_keep_after_navigation_change;
		// Emit message for listeners
		this.OBJ_subject.next({ type: "success", text: STR_message });
		// Store message to be available after navigation change
		this.OBJ_message_after_navigation_change = { type: "success", text: STR_message };

	} // end function success

	/**
	 * Function > info
	 * @param {string} STR_message
	 * @param {boolean} BOO_keep_after_navigation_change
	 */
	info(STR_message: string, BOO_keep_after_navigation_change = false)
	{

		this.BOO_keep_after_navigation_change = BOO_keep_after_navigation_change;
		// Emit message for listeners
		this.OBJ_subject.next({ type: "info", text: STR_message });
		// Store message to be available after navigation change
		this.OBJ_message_after_navigation_change = { type: "info", text: STR_message };
	} // end function info


	/**
	 * Function > error
	 * @param {string} STR_message
	 * @param {boolean} BOO_keep_after_navigation_change
	 */
	error(STR_message: string, BOO_keep_after_navigation_change = false)
	{

		this.BOO_keep_after_navigation_change = BOO_keep_after_navigation_change;
        // Emit message for listeners
		this.OBJ_subject.next({ type: "error", text: STR_message });
        // Store message to be available after navigation change
        this.OBJ_message_after_navigation_change = { type: "error", text: STR_message };
	} // end function error


	/**
	 * Function > getMessage
	 * @return {Observable<any>}
	 */
	getMessage(): Observable<any>
	{
		console.log(this.OBJ_subject.asObservable());
		return this.OBJ_subject.asObservable();
	} // end function getMessage


    /**
     * Function > getMessageAfterNavChange
     */
    getMessageAfterNavChange()
    {
        return this.OBJ_message_after_navigation_change;
    } // end function getMessage


} // end class AlertService
